export default {
  RETRIEVED_SERVICES: store => {
    return store.services;
  },
  RETRIEVED_SERVICE_TYPES: store => {
    return store.serviceTypes;
  }
};
